module.exports = __webpack_public_path__ + "static/turquia-023.thumb-4390d3ea20c246b853e8d785330407d1.jpg";